import React, { useEffect, useState } from 'react';
import { motion, useReducedMotion } from 'framer-motion';

/** True from the tablet breakpoint up — continuous float is desktop/tablet only. */
function useIsWideViewport() {
  const [isWide, setIsWide] = useState(false);
  useEffect(() => {
    const query = window.matchMedia('(min-width: 768px)');
    const update = () => setIsWide(query.matches);
    update();
    query.addEventListener('change', update);
    return () => query.removeEventListener('change', update);
  }, []);
  return isWide;
}
type FloatingPhotoProps = {
  children: React.ReactNode;
  className?: string;
  /** Vertical travel in pixels (kept between 2 and 8). */
  range?: number;
  /** Seconds for one full cycle (kept between 5 and 9). */
  duration?: number;
  /** Offset so photos never move in sync. */
  delay?: number;
};

/**
 * Calm, continuous float for real-photo cards. Disabled on small screens and
 * whenever the visitor prefers reduced motion.
 */
export function FloatingPhoto({
  children,
  className = '',
  range = 6,
  duration = 7,
  delay = 0
}: FloatingPhotoProps) {
  const reduceMotion = useReducedMotion();
  const isWide = useIsWideViewport();
  if (reduceMotion || !isWide) return <div className={className} data-id="element-290" data-mp="50ekp9bg4ovv">{children}</div>;
  return <motion.div className={className} animate={{
    y: [0, -range, 0]
  }} transition={{
    duration,
    repeat: Infinity,
    ease: 'easeInOut',
    delay
  }} data-id="element-291" data-mp="4xsdxbwdqdep">
      {children}
    </motion.div>;
}